// Helper functions to map API data to form and vice versa
import dayjs from 'dayjs';

import type { IncompleteEventFormComplete } from '../../../forms/event/IncompleteEventForm/schema.ts';
import { notEmpty } from '../../../lib/notEmpty.ts';
import { parseEventType } from '../../../mappers/incompleteEvent/apiToForm/lib/parseEventType.ts';
import { parseRecurrenceRate } from '../../../mappers/incompleteEvent/apiToForm/lib/parseRecurrenceRate.ts';
import type { IncompleteEventApiData } from './types.ts';

export const incompleteEventApiToIncompleteEventEditForm = (
  incompleteEventApiData: IncompleteEventApiData,
): IncompleteEventFormComplete => {
  const [defaultStartDate, defaultEndDate] = [
    dayjs().add(1, 'day').set('hour', 15).set('minute', 0).set('second', 0).toDate(),
    dayjs().add(1, 'day').set('hour', 16).set('minute', 0).set('second', 0).toDate(),
  ];

  return {
    name: incompleteEventApiData?.name ?? '',
    description: incompleteEventApiData?.description ?? { blocks: [] },
    websiteLink: incompleteEventApiData?.website_link ?? '',
    instagramLink: incompleteEventApiData?.instagram_link ?? '',
    tiktokLink: incompleteEventApiData?.tiktok_link ?? '',
    eventDetails:
      incompleteEventApiData?.event_details
        ?.map((eventDetail) => eventDetail?.event_details_id?.id?.toString(10))
        .filter(notEmpty) ?? [],
    tags:
      incompleteEventApiData?.target_audiences
        ?.map((targetAudience) => targetAudience?.target_audiences_id?.id?.toString(10))
        .filter(notEmpty) ?? [],

    image: (typeof incompleteEventApiData?.image === 'string' ? incompleteEventApiData.image : '') ?? '',
    image_original:
      (typeof incompleteEventApiData?.image_original === 'string'
        ? incompleteEventApiData.image_original
        : undefined) ?? undefined,
    image_crop_data: (incompleteEventApiData?.image_crop_data as { x: number; y: number; zoom: number } | null) ?? null,
    spotifyLink: incompleteEventApiData?.spotify_link ?? '',
    eventType: parseEventType(incompleteEventApiData?.type),
    venue: incompleteEventApiData?.venue?.id?.toString() ?? '',
    onlineLink: incompleteEventApiData?.online_link ?? '',
    start: incompleteEventApiData?.start ? dayjs(incompleteEventApiData?.start).toDate() : defaultStartDate,
    end: incompleteEventApiData?.end ? dayjs(incompleteEventApiData?.end).toDate() : defaultEndDate,
    recurrenceActive: incompleteEventApiData?.recurrence_active ?? false,
    recurrenceRate: parseRecurrenceRate(incompleteEventApiData?.recurrence_rate),
    recurrenceAmount:
      ((incompleteEventApiData as unknown as Record<string, unknown>)?.recurrence_amount as number) ?? null,
    recurrenceMonthType:
      ((incompleteEventApiData as unknown as Record<string, unknown>)?.recurrence_month_type as string) ??
      'nth-weekday-of-month',
    recurrenceDurationOption:
      ((incompleteEventApiData as unknown as Record<string, unknown>)?.recurrence_duration_option as string) ??
      'one-month',
    ticketshopLink: incompleteEventApiData?.ticket_sale_url ?? '',
    category: incompleteEventApiData?.category?.id?.toString(10) ?? '',
    customVenue: incompleteEventApiData?.custom_venue ?? '',
  };
};
